const translations = {
  "en": {
    "Content": "Content"
  },
  "zh-tw": {
    "Content": "內容"
  }
};

export default translations;
